var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHappinessWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "happinessWhite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Customised-Themes",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings-Direct-messages-",
    transform: "translate(-143.000000, -456.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "happinessWhite",
    transform: "translate(143.000000, 456.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9998514,0 C4.93454054,0 0,4.93454054 0,10.9998514 C0,17.0651622 4.93454054,21.9997027 10.9998514,21.9997027 C17.0651622,21.9997027 21.9997027,17.0651622 21.9997027,10.9998514 C21.9997027,4.93454054 17.0652365,0 10.9998514,0 Z M10.9998514,20.8105135 C8.30514865,20.8105135 5.86084459,19.7182432 4.08605405,17.9534865 C3.3772973,17.2487432 2.77564189,16.436527 2.30717568,15.5438919 C1.59366216,14.1845743 1.18918919,12.6386284 1.18918919,10.9998514 C1.18918919,5.59022973 5.59022973,1.18918919 10.9998514,1.18918919 C13.56575,1.18918919 15.9042905,2.17978378 17.6543311,3.79812162 C18.5616824,4.63709459 19.3109459,5.64463514 19.8512095,6.7707973 C20.4658716,8.05207432 20.8105135,9.48645946 20.8105135,10.9998514 C20.8105135,16.409473 16.409473,20.8105135 10.9998514,20.8105135 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 7.40760811,
    cy: 8.54714865,
    r: 1.18918919
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 14.7657162,
    cy: 8.54714865,
    r: 1.18918919
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9788176,17.094223 C13.2794527,17.094223 15.4842838,15.9176689 16.7466824,13.9642027 L15.7478378,13.3187703 C14.5886014,15.1125878 12.4682027,16.1136622 10.3449797,15.8686892 C8.69037162,15.6778986 7.16025676,14.7246149 6.25179054,13.3187703 L5.25302027,13.9642027 C6.35227703,15.6654122 8.20488514,16.8189257 10.2086689,17.0500743 C10.4659054,17.0797297 10.7227703,17.094223 10.9788176,17.094223 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappinessWhite);
export default __webpack_public_path__ + "static/media/happinessWhite.a15b88945f93d4d5b1919b8a9f920f66.svg";
export { ForwardRef as ReactComponent };